import React, { createContext, useContext, useEffect } from 'react';

import useSetSettings from '../../../../hooks/dashboard/settings/useSetSettings';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';
import { WhatIsNewContentDataInterface } from './WhatIsNewContentData';

interface IWhatIsNewModalProvider {
  children: React.ReactNode;
  data: WhatIsNewContentDataInterface[];
}
interface IWhatIsNewModalContext {
  onClickSkip: (...args: any) => void;
  onGetStarted: (...args: any) => void;
  onClickBack: (...args: any) => void;
  onClickNext: (...args: any) => void;
  onClickFinish: (...args: any) => void;
  contentLength?: number;
  setContentLength?: (...args: any) => void;
  data: WhatIsNewContentDataInterface[];
  registerSlideHeight: (index: number, height: number) => void;
  activeSlideHeight: number;
  activeSliderIndex: number;
  settingLoading: boolean;
}

export const WhatIsNewModalContext = createContext<IWhatIsNewModalContext>(
  null as unknown as IWhatIsNewModalContext,
);

const WhatIsNewModalProvider: React.FC<IWhatIsNewModalProvider> = ({
  children,
  data,
}) => {
  const modalContext = useContext(ModalContext);
  const translatingCtx = useContext(TranslatingContainerContext);
  const [contentLength, setContentLength] = React.useState(0);
  const [whatIsNewData, setWhatIsNewDataState] = React.useState<
    WhatIsNewContentDataInterface[]
  >([]);
  const [slideHeights, setSlideHeights] = React.useState<
    Record<number, number>
  >({});
  const { setSetting, loading: settingLoading } = useSetSettings();

  const registerSlideHeight = React.useCallback(
    (index: number, height: number) => {
      setSlideHeights((prev) => ({ ...prev, [index]: height }));
    },
    [],
  );

  const activeSlideHeight = slideHeights[translatingCtx?.sliderIndex ?? 0] ?? 0;

  useEffect(() => {
    setWhatIsNewDataState(data);
  }, [data]);

  const onClickSkip = (e: any) => {
    // localStorage.setItem(STORAGE_KEY, 'true');
    // modalContext?.setShowModal(!modalContext?.showModal);
    // translatingCtx?.resetSliderIndex();

    setSetting({ notified: true }, () => {
      modalContext?.setShowModal(!modalContext?.showModal);
      translatingCtx?.resetSliderIndex();
    });
  };

  const onGetStarted = (e: any) => {
    translatingCtx?.setSliderIndexPos(1);
  };

  const onClickBack = (e: any) => {
    translatingCtx?.setSliderIndexPos(-1);
  };

  const onClickNext = (e: any) => {
    translatingCtx?.setSliderIndexPos(1);
  };

  const onClickFinish = (e: any) => {
    // localStorage.setItem(STORAGE_KEY, 'true');

    setSetting({ notified: true }, () => {
      modalContext?.setShowModal(!modalContext?.showModal);
      translatingCtx?.resetSliderIndex();
    });
  };

  return (
    <WhatIsNewModalContext.Provider
      value={{
        onClickSkip,
        onGetStarted,
        onClickBack,
        onClickNext,
        onClickFinish,
        contentLength,
        setContentLength,
        data: whatIsNewData,
        registerSlideHeight,
        activeSlideHeight,
        activeSliderIndex: translatingCtx?.sliderIndex ?? 0,
        settingLoading,
      }}
    >
      {children}
    </WhatIsNewModalContext.Provider>
  );
};

export default WhatIsNewModalProvider;
